import { useState, useCallback } from 'react'

import { useAppDispatch } from 'redux/Hook'
import {
  deleteTheme as deleteThemeAction,
  getThemes,
} from 'redux/thunks/Themes'
import { setSelectedTheme } from 'redux/slices/Themes'
import { useAlert } from 'components/Shared/Alert'
import type { Theme } from 'containers/TextAnalysis/AIThemes/ThemeKeyPhrasesModal/Types'

export const useDeleteTheme = () => {
  const dispatch = useAppDispatch()
  const { showAlert } = useAlert()
  const [isLoading, setIsLoading] = useState(false)

  const deleteTheme = useCallback(
    async (theme: Theme) => {
      if (!theme || !theme.id) return false

      try {
        setIsLoading(true)

        await dispatch(deleteThemeAction({ themeId: theme.id })).unwrap()
        await dispatch(getThemes())

        // Reset the selected theme after deletion
        dispatch(setSelectedTheme(null))

        showAlert({
          type: 'success',
          title: `Successfully deleted theme "${theme.attributes.name}"`,
        })

        return true
      } catch {
        return false
      } finally {
        setIsLoading(false)
      }
    },
    [dispatch, showAlert],
  )

  return { loading: { isLoading }, deleteTheme }
}
